import { validadeCnpj, validadeCpf } from 'v2/resources/utils/formatCpfAndCpnj';
import * as Yup from 'yup';

export const userSchema: Yup.Schema = Yup.object().shape({
  name: Yup.string()
    .required('Campo Obrigatório')
    .min(3, 'Minimo de 3 caracteres'),
  cpfCnpj: Yup.string()
    .required('Campo Obrigatório')
    .test('validade-cpf-cnpj', 'CPF/CNPJ inválido', (value) => {
      if (!value) return false;

      if (value.length < 11) return false;

      if (value.length === 11) {
        return validadeCpf(value);
      }
      if (value.length === 14) {
        return validadeCnpj(value);
      }

      const newValue = value.replace(/[^\d]/g, '');
      return newValue.length === 11 || newValue.length === 14;
    }),
  cellphone: Yup.string()
    .required('Campo Obrigatório')
    .test('is-valid', 'Numero inválido', (value) => {
      if (!value) return false;
      const newValue = value.replace(/[^\d]/g, '');
      return newValue.length === 11;
    }),
  email: Yup.string().required('Campo Obrigatório').email('E-mail inválido'),
  function: Yup.string()
    .required('Campo Obrigatório')

    .min(3, 'Minimo de 3 caracteres'),
});

export default userSchema;
